import React, { useState, useEffect } from "react";

import onlineDegreeGovJobs from "../blogs/onlineDegreeGovJobs";
import onlineMBAWorthIt from "../blogs/onlineMBAWorthIt";
import careerGrowthMBA from "../blogs/careerGrowthMBA";
import chooseOnlineDegree from "../blogs/chooseOnlineDegree";

const posts = [
  onlineDegreeGovJobs,
  onlineMBAWorthIt,
  careerGrowthMBA,
  chooseOnlineDegree,
];

function BlogCard(props) {
  var post = props.post;
  var index = props.index;
  var hovered = props.hovered;
  var setHovered = props.setHovered;
  var openBlog = props.openBlog;

  var isHovered = hovered === index;

  return React.createElement(
    'div',
    {
      onMouseEnter: function () { setHovered(index); },
      onMouseLeave: function () { setHovered(null); },
      style: {
        background: '#FFFFFF',
        border: '1.5px solid #E5E9F2',
        borderRadius: '16px',
        overflow: 'hidden',
        transition: 'all 0.35s ease',
        transform: isHovered ? 'translateY(-6px)' : 'translateY(0)',
        boxShadow: isHovered ? '0 20px 80px rgba(11,31,74,0.16)' : '0 8px 48px rgba(11,31,74,0.10)',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
      }
    },
    // Color header
    React.createElement(
      'div',
      {
        style: {
          background: post.categoryColor,
          padding: '28px 24px',
          position: 'relative',
          overflow: 'hidden',
          minHeight: '100px',
          display: 'flex',
          alignItems: 'flex-end',
          justifyContent: 'space-between',
        }
      },
      React.createElement('div', null,
        React.createElement(
          'span',
          {
            style: {
              background: 'rgba(245,197,24,0.2)',
              color: '#F5C518',
              fontSize: '10px',
              fontWeight: 800,
              padding: '4px 10px',
              borderRadius: '999px',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              display: 'inline-block',
              marginBottom: '8px',
              marginRight: '8px',
            }
          },
          post.category
        ),
        React.createElement(
          'span',
          {
            style: {
              background: '#F5C518',
              color: '#0B1F4A',
              fontSize: '9px',
              fontWeight: 800,
              padding: '3px 8px',
              borderRadius: '999px',
              textTransform: 'uppercase',
              display: 'inline-block',
            }
          },
          post.tag
        )
      ),
      React.createElement('div', { style: { fontSize: '40px' } }, post.emoji)
    ),
    // Card body
    React.createElement(
      'div',
      {
        style: {
          padding: '24px',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
        }
      },
      React.createElement(
        'h3',
        {
          style: {
            fontFamily: 'Playfair Display, serif',
            fontSize: '18px',
            color: '#0B1F4A',
            lineHeight: 1.4,
            marginBottom: '12px',
          }
        },
        post.title
      ),
      React.createElement(
        'p',
        {
          style: {
            fontSize: '13.5px',
            color: '#6B7280',
            lineHeight: 1.7,
            marginBottom: '20px',
            flex: 1,
          }
        },
        post.excerpt
      ),
      // Meta row
      React.createElement(
        'div',
        {
          style: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid #E5E9F2',
            paddingTop: '14px',
            marginBottom: '14px',
            flexWrap: 'wrap',
            gap: '8px',
          }
        },
        React.createElement('div', null,
          React.createElement('div', { style: { fontSize: '12px', fontWeight: 700, color: '#0B1F4A' } }, post.author),
          React.createElement('div', { style: { fontSize: '11px', color: '#6B7280', marginTop: '2px' } }, post.date)
        ),
        React.createElement(
          'span',
          {
            style: {
              fontSize: '11px',
              color: '#6B7280',
              background: '#F8F9FC',
              padding: '4px 10px',
              borderRadius: '999px',
              fontWeight: 600,
            }
          },
          '⏱ ' + post.readTime
        )
      ),
      // CTA
      React.createElement(
        "button",
        {
          onClick: function () {
            openBlog(post);
          },

          style: {
            display: "block",
            width: "100%",
            textAlign: "center",
            background: isHovered ? "#0B1F4A" : "#F8F9FC",
            color: isHovered ? "#F5C518" : "#0B1F4A",
            padding: "11px",
            borderRadius: "8px",
            fontWeight: 700,
            fontSize: "13px",
            transition: "all 0.25s",
            border: "1.5px solid #E5E9F2",
            cursor: "pointer",
          },
        },
        "Read Article →"
      )
    )
  );
}
function BlogModal(props) {

  var blog = props.blog;
  var onClose = props.onClose;

  if (!blog) return null;

  return React.createElement(

    "div",

    {

      onClick: onClose,

      style: {

        position: "fixed",

        top: 0,

        left: 0,

        width: "100vw",

        height: "100vh",

        background: "rgba(0,0,0,.65)",

        backdropFilter: "blur(6px)",

        display: "flex",

        justifyContent: "center",

        alignItems: "center",

        padding: "30px",

        zIndex: 9999

      }

    },
    React.createElement(

      "div",

      {

        onClick: function (e) {

          e.stopPropagation();

        },

        style: {

          width: "100%",

          maxWidth: "900px",

          maxHeight: "90vh",

          overflowY: "auto",

          background: "#fff",

          borderRadius: "18px",

          padding: "45px",

          boxShadow: "0 20px 80px rgba(0,0,0,.25)",

          position: "relative"

        }

      },
      React.createElement(

        "button",

        {

          onClick: onClose,

          style: {

            position: "absolute",

            top: "20px",

            right: "20px",

            width: "42px",

            height: "42px",

            borderRadius: "50%",

            border: "none",

            background: "#F3F4F6",

            cursor: "pointer",

            fontSize: "22px",

            fontWeight: 700

          }

        },

        "×"

      ), React.createElement(

        "span",

        {

          style: {

            background: blog.categoryColor,

            color: "#fff",

            padding: "6px 14px",

            borderRadius: "999px",

            fontWeight: 700,

            fontSize: "12px"

          }

        },

        blog.category

      ),
      React.createElement(

        "h1",

        {

          style: {

            fontFamily: "Playfair Display, serif",

            color: "#0B1F4A",

            marginTop: "20px",

            fontSize: "42px",

            lineHeight: 1.2

          }

        },

        blog.title

      ),
      React.createElement(

        "p",

        {

          style: {

            color: "#666",

            marginBottom: "40px"

          }

        },

        blog.author,

        " • ",

        blog.date,

        " • ",

        blog.readTime

      ), blog.content.map(function (section, index) {

        return React.createElement(

          "div",

          {

            key: index,

            style: {

              marginBottom: "38px"

            }

          },

          React.createElement(

            "h2",

            {

              style: {

                color: "#0B1F4A",

                fontSize: "30px",

                marginBottom: "16px",

                fontFamily: "Playfair Display, serif"

              }

            },

            section.heading

          ),

          React.createElement(

            "p",

            {

              style: {

                color: "#555",

                fontSize: "17px",

                lineHeight: 1.9,

                whiteSpace: "pre-wrap"

              }

            },

            section.body

          )

        );

      }), React.createElement(

        "div",

        {

          style: {

            marginTop: "50px",

            paddingTop: "35px",

            borderTop: "1px solid #E5E7EB",

            textAlign: "center"

          }

        },

        React.createElement(

          "h3",

          {

            style: {

              color: "#0B1F4A",

              marginBottom: "12px",

              fontSize: "26px"

            }

          },

          "Ready to Start Your Higher Education Journey?"

        ),

        React.createElement(

          "p",

          {

            style: {

              color: "#666",

              marginBottom: "24px",

              fontSize: "16px"

            }

          },

          "Our experts can help you choose the right university and program."

        ),

        React.createElement(

          "a",

          {

            href: "#contact",

            onClick: onClose,

            style: {

              display: "inline-block",

              background: "#0B1F4A",

              color: "#F5C518",

              padding: "14px 28px",

              borderRadius: "10px",

              fontWeight: 700,

              textDecoration: "none"

            }

          },

          "Book Free Counselling"
        )

      )
     )
    );

}
export default function Blog() {

  var hovered = useState(null);
  var hoveredIndex = hovered[0];
  var setHovered = hovered[1];

  var blogState = useState(null);
  var selectedBlog = blogState[0];
  var setSelectedBlog = blogState[1];

  function openBlog(blog) {
    setSelectedBlog(blog);
  }

  function closeBlog() {
    setSelectedBlog(null);
  }

  useEffect(function () {

    function esc(e) {
      if (e.key === "Escape") {
        closeBlog();
      }
    }

    window.addEventListener("keydown", esc);

    return function () {
      window.removeEventListener("keydown", esc);
    };

  }, []);


  return React.createElement(
    'section',
    {
      id: 'blog',
      style: {
        padding: '100px 5%',
        background: '#FFFFFF',
      }
    },
    // Header row
    React.createElement(
      'div',
      {
        style: {
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-end',
          flexWrap: 'wrap',
          gap: '20px',
          marginBottom: '48px',
        }
      },
      React.createElement('div', null,
        React.createElement(
          'span',
          {
            style: {
              display: 'inline-block',
              color: '#F5C518',
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '2.5px',
              textTransform: 'uppercase',
              marginBottom: '14px',
              background: 'rgba(11,31,74,0.07)',
              padding: '5px 14px',
              borderRadius: '999px',
            }
          },
          'iGrade Blog'
        ),
        React.createElement(
          'h2',
          {
            style: {
              fontFamily: 'Playfair Display, serif',
              fontSize: 'clamp(32px,4vw,52px)',
              color: '#0B1F4A',
              lineHeight: 1.08,
              maxWidth: '640px',
              marginBottom: '12px',
            }
          },
          'Insights & ',
          React.createElement('em', { style: { fontStyle: 'italic' } }, 'Success Stories')
        ),
        React.createElement(
          'p',
          {
            style: {
              fontSize: '17px',
              color: '#6B7280',
              maxWidth: '560px',
              lineHeight: 1.75,
            }
          },
          'Education tips, career advice, university news and real student journeys.'
        )
      ),
      React.createElement(
        'a',
        {
          href: '#contact',
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: '#0B1F4A',
            color: '#F5C518',
            padding: '12px 24px',
            borderRadius: '10px',
            fontWeight: 700,
            fontSize: '14px',
            transition: 'all 0.25s',
            whiteSpace: 'nowrap',
            textDecoration: 'none',
          }
        },
        'View All Posts →'
      )
    ),
    // Cards grid
    React.createElement(
  React.Fragment,
  null,

  React.createElement(
    'div',
    {
      style: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: '24px',
      }
    },
    posts.map(function (post, i) {
      return React.createElement(BlogCard, {
        key: post.id,
        post: post,
        index: i,
        hovered: hoveredIndex,
        setHovered: setHovered,
        openBlog: openBlog,
      });
    })
  ),

  selectedBlog &&
    React.createElement(BlogModal, {
      blog: selectedBlog,
      onClose: closeBlog,
    })
  )
)
}